import { FC, MouseEventHandler } from 'react'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

interface Props {
  onClick: MouseEventHandler<HTMLButtonElement>
  className?: string
  disabled?: boolean
}

const useStyles = createUseStyles({
  button: {
    margin: 0,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
})

export const Button: FC<Props> = flowMax(
  addDisplayName('Button'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ children, className, classes, onClick, disabled }) => (
    <button
      onClick={onClick}
      className={cx(classes.button, className)}
      disabled={disabled}
    >
      {children}
    </button>
  )
)
